// import patron from "./patron";
import manager from "./manager";
import accreditation from "./accreditation";
import admissions from "./admissions";
import accounting from "./accounting";
import carpentry from "./carpentry";
import cashier from "./cashier";
import clinical from "./clinical";
import frontdesk from "./frontdesk";
import headquarter from "./headquarter";
import humanresources from "./hr";
import nutritionist from "./nutritionist";
import pharmacist from "./pharmacist";
import procurement from "./procurement";
import utility from "./utility";
import diagnostic from "./diagnostic";
import laboratory from "./laboratory";
import radiology from "./radiology";
import physician from "./physician";

const diagnostics = {
  utility,
  procurement,
  pharmacist,
  nutritionist,
  headquarter,
  humanresources,
  frontdesk,
  cashier,
  clinical,
  carpentry,
  admissions,
  accounting,
  accreditation,
  manager,
  // patron,
  diagnostic,
  laboratory,
  radiology,
  physician,
};

export default diagnostics;
